module.exports = __webpack_public_path__ + "static/media/vend-logo-white.d95af1ba.svg";